// extracted by mini-css-extract-plugin
export default {"table":"styles_table__AffXB","modal":"styles_modal__NLkiU"};